import React from "react";
import { Link } from "react-router-dom";

function Home() {
  return (
    <>
    
      <div className=" container d-flex justify-content-center align-items-center home-container" >
        <div className="row my-3">
          <div className="col text-center">
            <p className="text-white display-4 m-0">Hi <span class="waveHello">👋🏻</span> I'm</p>
            <h1 className="display-0 fw-bold text-white">G Rohit</h1>
            <p className="fs-3 text-white">
              I design & develop visually appealing websites
            </p>
            <div className="m-5">
              <Link to="/projects" className="button">
                See my Projects &nbsp;&rarr;
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Home;
